import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ListFilter } from '../models/ListCuisines';

@Injectable({
  providedIn: 'root'
})
export class CuisinesService {

  refreshList = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(filter: ListFilter): any {
    return this.http.post(`${environment.apiUrl}/Lookup/GetAllCuisines`, filter);
  }
  GetCuisines() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCuisines`);
  }
  GetDetails(id: string) {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCuisinesById?id=${id}`);
  }
  delete(id: string) {
    return this.http.post(`${environment.apiUrl}/Lookup/DeleteCuisines?id=${id}`, null);
  }
  saveRecord(data: any) {
    if (data.id) {
      return this.http.post(`${environment.apiUrl}/Lookup/EditCuisines`, data);
    } else {
      return this.http.post(`${environment.apiUrl}/Lookup/NewCuisines`, data);
    }
  }
}
